import React from 'react';
import {Outlet} from 'react-router-dom';
import {PoppaysLoader} from '@lightricks/react-design-system';
import OffPlatformHeader from '@/components/off-platform-header';
import useOffPlatformShareTokenStatus from '@/hooks/off-platform/useOffPlatformShareTokenStatus';
import useRedirectToCampaignsIfAuthenticated from '@/hooks/use-redirect-if-authenticated/useRedirectToCampaignsIfAuthenticated';
import OffPlatformExpiredLink from './OffPlatformExpiredLink';
import styles from './OffPlatformLayout.module.scss';

function OffPlatformLayout() {
  const {isCheckingAuth} = useRedirectToCampaignsIfAuthenticated();
  const {isExpired} = useOffPlatformShareTokenStatus();

  if (isCheckingAuth) {
    return <PoppaysLoader />;
  }

  if (isExpired) {
    return (
      <div className={styles.container}>
        <OffPlatformExpiredLink />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <OffPlatformHeader />
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
}

export default OffPlatformLayout;
